import { render, staticRenderFns } from "./MediaTags.vue?vue&type=template&id=bb2bfdae&"
import script from "./MediaTags.vue?vue&type=script&lang=ts&"
export * from "./MediaTags.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports